import ArticleSummary from '@/domains/blog/components/ArticleSummary';
import CategoryList   from '@/domains/blog/components/CategoryList';
import Header         from '@/domains/blog/components/Header';
import Pagination     from '@/domains/blog/components/Pagination';

export default function ArticleListPage({
	                                        authors,
	                                        articles,
	                                        categories,
	                                        currentCategorySlug = null,
	                                        currentPage = 1,
	                                        firstPage = 1,
	                                        lastPage = 1,
	                                        hrefForPage,
                                        }) {
	const category = categories[currentCategorySlug] ?? null;

	return (<div className="lg:mx-0 lg:max-w-none grid gap-8">
		<Header categorySlug={category?.slug}
		        categoryName={category?.name}
		        h1={true}
		/>

		<div className="grid grid-cols-1 gap-8 lg:grid-cols-4">
			<div className="flex flex-col justify-start gap-8 backdrop-blur backdrop-opacity-20">
				<CategoryList categories={Object.values(categories)}
				              currentCategorySlug={currentCategorySlug}
				              className="bg-teal-700 rounded-2xl p-4"
				/>
			</div>

			<div className="lg:col-span-3">
				{articles.slice(0, 1)
				         .map((article, index) => {
					         const articleAuthors = article.authors.map((author) => {
						         return authors[author];
					         });

					         return (<ArticleSummary key={index}
					                                 article={article}
					                                 authors={articleAuthors}
					                                 category={categories[article.category]}
					                                 featured={true}
					         />);
				         })}
			</div>
		</div>

		{articles.length > 1 && <div className="grid lg:grid-cols-3 gap-8">
			{articles.slice(1)
			         .map((article, index) => {
				         const articleAuthors = article.authors.map((author) => {
					         return authors[author];
				         });

				         return (<ArticleSummary key={index}
				                                 article={article}
				                                 authors={articleAuthors}
				                                 category={categories[article.category]}
				                                 featured={false}
												 className=""
				         />);
			         })}
		</div>}

		{lastPage > 1 && <Pagination currentPage={currentPage}
		                             firstPage={firstPage}
		                             lastPage={lastPage}
		                             hrefForPage={hrefForPage}
		/>}
	</div>);
}
